module.exports = __webpack_public_path__ + "img/horizontal_7_5_6005.1a83ace9.png";